/**
 * Re-exported from the shared calculation, not reimplemented.
 *
 * The downsize mutator moved to `shared/src/calculation/support/downsizeEvent.ts` so the projection
 * engine can execute it on a DATED day against live balances (`downsizeEventPlugin`). This wrapper
 * keeps the original call signature — callers pass a DraftFactFind and get one back — so the Support
 * at Home and Downsizer modules did not have to change.
 */
import { applyDownsizeEventToFactFind } from '../../../../shared/src/calculation/support/downsizeEvent.ts';
import type { DraftFactFind } from '../../constants/initialFactFind.ts';
import type { DownsizeDetails } from '../../strategy/supportAtHomeStrategyFunding.ts';
import type { FactFind } from '../../../../shared/src/calculation/factFindTypes.ts';

export const applyDownsizeToFactFind = (factFind: DraftFactFind, details: Partial<DownsizeDetails> = {}): DraftFactFind =>
    applyDownsizeEventToFactFind(factFind as unknown as FactFind, details as never).factFind as unknown as DraftFactFind;
